import * as React from 'react';
import { Outlet , useNavigate} from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import { 
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Button
 } from '@mui/material';
 
import { Confirmation } from '../utils';
import { CONST, TokenValidator } from '../../utils';
import NavigationActions from '../navigationActions';

export default function Holder() {
    document.title = 'Shipping Station';
    const nav = useNavigate();
    
    const [logoutUi, showUi] = React.useState(false);
    const [loged, isLoged] = React.useState(false);
    
    const LoginContext = {
        didLogin : isLoged
    }

    const HolderContex = {
        Login : LoginContext
    }

    const logout = async() => {
        CONST.PM_LOGOUT_KEYS.forEach(x => {
            localStorage.removeItem(x);
        })
        showUi(false);
        isLoged(false);
        nav('');
    }   

    return(
        <Box>
            <AppBar 
                position="static"
            >
                <Toolbar
                    sx={{
                        gap: 2
                    }}
                >
                <NavigationActions />

                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    SHIPPING STATION
                </Typography>

                {loged && (
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={() => showUi(true)}
                    >
                        <LogoutIcon />
                    </IconButton>
                )}

                
                </Toolbar>
            </AppBar>
            
            <Confirmation 
                open={logoutUi} 
                onClose={() => showUi(false)} 
                onConfirm={(logout)} 
                title={'Log Out'} 
                msg={'Please, confirm to logout from Order Management Portal'}
            />

            <Outlet context={HolderContex}/>
        </Box>
    );
}
